"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_LOG_TYPE = void 0;
exports.ERROR_LOG_TYPE = {
    STATE_NOT_FOUND: 'client side router state not found',
    STATE_CHANGE_FAILED: 'client side router state change error',
    GET_NOTHING_FROM_SERVER: 'get nothing from server',
    USER_NONE_PERMISSION: "user don't have permission for resource from server",
    UNKNOWN_ERROR: 'unknown error from server',
};
//# sourceMappingURL=ErrorLogType.js.map